
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import FloatingWhatsApp from '@/components/FloatingWhatsApp';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

const Book = () => {
  const { t } = useLanguage();
  
  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-black flex items-center">
        <div className="container mx-auto px-6 md:px-8 lg:px-12 py-16 pt-24">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-8 animate-fade-in-up lg:text-4xl">Funnel Like a Pro</h1>
            
            <div className="flex justify-center mb-8 animate-fade-in-up" style={{
            animationDelay: '0.1s'
          }}>
              <div className="relative w-64 h-80 bg-dark-200 rounded-lg flex items-center justify-center shadow-lg">
                <img src="/lovable-uploads/13699593-9964-4615-930a-713f85095af1.png" alt="Funnel Like a Pro Book" className="w-full h-full object-cover rounded-lg" />
              </div>
            </div>
            
            <p className="text-xl text-gray-300 mb-8 animate-fade-in-up" style={{
            animationDelay: '0.2s'
          }}>
              Ένας πλήρης οδηγός για funnels, VSLs και online πωλήσεις το 2025.
              Μάθετε πώς να δημιουργείτε funnel-based συστήματα που πουλάνε, με πρακτικά παραδείγματα, 
              AI εργαλεία, scripts και στρατηγικές που εφαρμόζετε από την πρώτη μέρα.
            </p>
            
            <div className="bg-dark-300 rounded-lg p-6 mb-12 animate-fade-in-up" style={{
            animationDelay: '0.25s'
          }}>
              <p className="text-lg text-gray-200 mb-4">
                Είτε είστε αρχάριος είτε θέλετε να προσφέρετε funnels σαν υπηρεσία, αυτό το eBook σας δείχνει βήμα προς βήμα:
              </p>
              
              <ul className="text-left space-y-3 mb-0 text-gray-300">
                <li className="flex items-center">
                  <span className="text-brand mr-2">✓</span> Πώς να χτίζετε VSLs που μετατρέπουν
                </li>
                <li className="flex items-center">
                  <span className="text-brand mr-2">✓</span> Πώς να στήσετε ένα funnel από το 0
                </li>
                <li className="flex items-center">
                  <span className="text-brand mr-2">✓</span> Πώς να πουλήσετε τις υπηρεσίες σας σωστά
                </li>
                <li className="flex items-center">
                  <span className="text-brand mr-2">✓</span> Πώς να προσελκύσετε πελάτες και να κάνετε upsell
                </li>
                <li className="flex items-center">
                  <span className="text-brand mr-2">✓</span> Πώς να αξιοποιήσετε AI tools & automations
                </li>
              </ul>
            </div>
            
            <div className="animate-fade-in-up" style={{
            animationDelay: '0.3s'
          }}>
              <Button asChild className="bg-brand hover:bg-brand-hover text-white font-medium text-lg px-8 py-6" size="lg">
                <a href="https://drive.google.com/file/d/1n_bVQa8VV5XCW6JrEYieTa4IrkTfQfnL/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                  <Download className="w-5 h-5 mr-2" />
                  Κατεβάστε το eBook Δωρεάν
                </a>
              </Button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
};

export default Book;
